import React from "react";
import { observer } from "mobx-react";
import { ShowcaseLineCreateStore } from "../../store";
import { ShowcaseLineCreateForm } from "./ShowcaseLineCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type ShowcaseLineCreateProps = {
  showcaseLineCreateStore: ShowcaseLineCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const ShowcaseLineCreate: React.FC<ShowcaseLineCreateProps> = observer(
  ({ showcaseLineCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={showcaseLineCreateStore.isSaving} />
        <ShowcaseLineCreateForm
          showcaseLineCreateStore={showcaseLineCreateStore}
          conceptError={showcaseLineCreateStore.errors.concept?.message}
          onConceptChange={(value: string) => {
            showcaseLineCreateStore.setConceptValue(value);
          }}
          concept={showcaseLineCreateStore.entityValues.concept}
          quantityError={showcaseLineCreateStore.errors.quantity?.message}
          onQuantityChange={(value: number) => {
            showcaseLineCreateStore.setQuantityValue(value);
          }}
          quantity={showcaseLineCreateStore.entityValues.quantity}
          unitPriceError={showcaseLineCreateStore.errors.unitPrice?.message}
          onUnitPriceChange={(value: number) => {
            showcaseLineCreateStore.setUnitPriceValue(value);
          }}
          unitPrice={showcaseLineCreateStore.entityValues.unitPrice}
          noteError={showcaseLineCreateStore.errors.note?.message}
          onNoteChange={(value: string) => {
            showcaseLineCreateStore.setNoteValue(value);
          }}
          note={showcaseLineCreateStore.entityValues.note}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={showcaseLineCreateStore.isProcessing}
          onSave={() => showcaseLineCreateStore.saveNewShowcaseLine()}
          onCancel={() => showcaseLineCreateStore.cancelNewShowcaseLine()}
        />
        <ErrorDialog
          open={showcaseLineCreateStore.errorDialogOpened}
          title={showcaseLineCreateStore.errorTitle}
          description={showcaseLineCreateStore.errorDescription}
          onClose={() => showcaseLineCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
